// extracted by mini-css-extract-plugin
export default {"comparisonCtrls":"index_comparisonCtrls__Fv4SL"};